/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Dialog, InlineNotification, Link, useTheme } from '@coursera/cds-core';

import DiscussionsModal from 'bundles/discussions/components/DiscussionsModal';
import CopyTextButton from 'bundles/ui/components/CopyTextButton';

import _t from 'i18n!nls/discussions';

const styles = {
  content: css`
    max-width: 100%;
    word-wrap: break-word;
  `,
};

type Props = {
  handleClose: () => void;
  postUrl: string;
};

const ShareModal: React.FC<Props> = ({ postUrl, handleClose }) => {
  const { HeadingGroup, Content, Actions } = Dialog;
  const theme = useTheme();
  const [status, setStatus] = useState<'default' | 'success' | 'failed'>('default');

  const buttonLabel = _t('Copy link to share');

  const notificationLabel = status === 'success' ? _t('Link copied successfully') : _t('Link didn’t copy—try again');
  const notificationSeverity = status === 'success' ? 'success' : 'error';

  const visibility = status !== 'default' ? 'visible' : 'hidden';

  return (
    <DiscussionsModal handleClose={handleClose} modalName={_t('Share Post')}>
      <HeadingGroup>{_t('Share Post')}</HeadingGroup>
      <Content id="dialog-content" css={styles.content}>
        <Link href={postUrl} typographyVariant="bodySecondary">
          {postUrl}
        </Link>
      </Content>
      <Actions>
        <CopyTextButton textToCopy={postUrl} defaultLabel={buttonLabel} status={status} setStatus={setStatus} />
        <div aria-label={notificationLabel} aria-live="polite" role="alert">
          {status !== 'default' && (
            <InlineNotification
              severity={notificationSeverity}
              css={{ marginTop: 'var(--cds-spacing-200)', visibility }}
            >
              {notificationLabel}
            </InlineNotification>
          )}
        </div>
      </Actions>
    </DiscussionsModal>
  );
};

export default ShareModal;
